import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  dashboard: () => __(translations.usersPage.dashboard, 'Dashboard'),
};
